<div style="position:fixed;top:20px;right:20px;z-index:999999;display:flex;flex-direction:column;gap:8px;pointer-events:none;">
  @for (toast of toasts; track toast.id) {
    <div
      style="width:320px;padding:14px 16px;border-radius:8px;display:flex;align-items:flex-start;gap:12px;pointer-events:all;box-shadow:0 8px 32px rgba(0,0,0,0.45);animation:toastSlideIn 0.25s cubic-bezier(0.2,0.8,0.2,1);"
      [style.background]="'#1a1d22'"
      [style.border]="'1px solid ' + (toast.type === 'error' ? '#ff3d71' : toast.type === 'warning' ? '#ffaa00' : toast.type === 'info' ? '#00f0ff' : '#00d68f')"
      [style.border-left]="'3px solid ' + (toast.type === 'error' ? '#ff3d71' : toast.type === 'warning' ? '#ffaa00' : toast.type === 'info' ? '#00f0ff' : '#00d68f')"
    >
      <div style="flex-shrink:0;width:16px;height:16px;display:flex;align-items:center;justify-content:center;margin-top:2px;"
        [style.color]="toast.type === 'error' ? '#ff3d71' : toast.type === 'warning' ? '#ffaa00' : toast.type === 'info' ? '#00f0ff' : '#00d68f'">
        @if (toast.type === 'success') {
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M13.5 4.5L6.5 11.5L3 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        } @else if (toast.type === 'error') {
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        } @else if (toast.type === 'warning') {
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8 6V9M8 11.5V12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M6.857 2.617L1.215 12.25A1.3 1.3 0 0 0 2.358 14.25H13.642a1.3 1.3 0 0 0 1.143-1.999L9.143 2.617a1.3 1.3 0 0 0-2.286 0Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
          </svg>
        } @else {
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="1.5"/>
            <path d="M8 7V11M8 5V5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        }
      </div>

      <div style="flex:1;min-width:0;">
        <div style="font-size:0.7rem;font-weight:700;text-transform:uppercase;letter-spacing:0.05em;margin-bottom:3px;"
          [style.color]="toast.type === 'error' ? '#ff3d71' : toast.type === 'warning' ? '#ffaa00' : toast.type === 'info' ? '#00f0ff' : '#00d68f'">
          {{ toast.title }}
        </div>
        <div style="font-size:0.82rem;color:#8a8f98;line-height:1.4;">{{ toast.message }}</div>
      </div>

      <button
        style="flex-shrink:0;background:none;border:none;color:#8a8f98;cursor:pointer;padding:2px;"
        (click)="toastService.dismiss(toast.id)" title="Dismiss">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M10 2L2 10M2 2L10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>
    </div>
  }
</div>
